import type { IFinancialCockpitState } from '../model/types'

export interface ICockpitPartnerScopeStatus {
  bitValue: number
  /** Offering the status was raised for; `null` where the row states none. */
  offering: string | null
}

/**
 * The cockpit's state as the single-partner cockpit would hold it for one partner of the manager
 * cockpit's payload.
 *
 * The manager payload already carries every partner's rows, so the status sections — written for
 * a payload of one partner — read the same state reduced to that partner rather than being told
 * the partner through every selector they use. The status the section answers is set as the one
 * the tile would have selected.
 */
export const scopeCockpitStateToPartner = (
  state: IFinancialCockpitState,
  partnerId: string,
  status: ICockpitPartnerScopeStatus | null
): IFinancialCockpitState => ({
  ...state,
  cockpitMode: 'partner',
  partnerData: state.partnerData.filter(({ PartnerId }) => PartnerId === partnerId),
  finSobData: state.finSobData.filter((row) => row.partnerId === partnerId),
  keyInitiatives: state.keyInitiatives.filter(({ PartnerId }) => PartnerId === partnerId),
  mdfActivities: state.mdfActivities.filter((activity) => activity.partnerId === partnerId),
  mdfSales: (state.mdfSales ?? []).filter(({ PartnerId }) => PartnerId === partnerId),
  pendingActions: state.pendingActions.filter(({ PartnerId }) => PartnerId === partnerId),
  users: state.users.filter(({ PartnerId }) => PartnerId === partnerId),
  completenessData: state.completenessData.filter(({ PartnerId }) => PartnerId === partnerId),
  offeringsCatalog: state.offeringsCatalog.filter((entry) => entry.partnerId === partnerId),
  commitmentData: state.commitmentData.filter(({ PartnerId }) => PartnerId === partnerId),
  selectedAttentionStatusBit: status?.bitValue ?? null,
  selectedAttentionStatusOffering: status?.offering ?? null,
})
